import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c20c3828"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid m-0 list-booking-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, "予約日"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, "予約枠"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, "予約ステータス")
], -1))
const _hoisted_2 = { class: "col-3 td" }
const _hoisted_3 = { class: "col-6 td" }
const _hoisted_4 = { class: "col-3 td" }

import { ref, onMounted } from "vue";
import { get, useDateFormat } from "@vueuse/core";
import type { IBooking } from "@/clinic/typings";
import TimeUtils from "@/clinic/utils/time-utils";
import RouterUtils from "@/common/utils/router.util";
import RouterConstants from "@/clinic/constants/router.constants";

import { DATE_FORMAT } from "@/clinic/typings/constants/booking";
import { BookingStatusEnum } from "@/clinic/typings/enums/booking";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingHistory',
  props: {
    bookings: null,
    customerId: null
  },
  setup(__props: any) {

const props = __props as {
  bookings: IBooking[];
  customerId: number;
};


const bookingHistoryClick = () => {
  RouterUtils.goToWithQuery(RouterConstants.DIRECT_MESSAGE_ROUTER_NAME, {
    customerId: props.customerId,
  });
};

const bookingsVal = ref<IBooking[]>([]);
const initAttributes = () => {
  if (!bookingsVal.value.length) {
    bookingsVal.value = props.bookings;
  }
};
const rangeTime = (start: Date, end: Date) => {
  if (!start || !end) return "";
  return TimeUtils.formatRangeDateTime(start, end);
};
onMounted(() => {
  initAttributes();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", {
      class: "customer-list-booking overflow-auto h-full",
      onClick: bookingHistoryClick
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookingsVal.value, (booking, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "grid m-0",
          key: index
        }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(get)(_unref(useDateFormat)(booking.start_time, _unref(DATE_FORMAT)))), 1),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(get)(rangeTime(booking.start_time, booking.end_time))), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(BookingStatusEnum)[booking.status]), 1)
        ]))
      }), 128))
    ])
  ], 64))
}
}

})